import React from 'react';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import SolutionExtras, { SolutionSeo } from '../../components/SolutionExtras';
import { SOLUTIONS } from '../../data/solutions';

const S = SOLUTIONS.enterprise;
import { Building2, Shield, Zap, Globe, CheckCircle2, Users } from 'lucide-react';

const Enterprise = () => {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <SolutionSeo s={S} name="Enterprise" />
      {/* Hero Section */}
      <section className="px-4 sm:px-6 lg:px-8 mb-16">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl font-bold mb-6" style={{ color: '#0a1f2e' }}>
            Enterprise Communications
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Scalable, reliable VoIP solutions designed for large organizations with complex communication needs.
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="px-4 sm:px-6 lg:px-8 mb-16">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold mb-8" style={{ color: '#0a1f2e' }}>{S.featuresTitle}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Building2 className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Multi-Site Support</h3>
              <p className="text-gray-600">Connect offices globally with unified communications</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Shield className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Enterprise Security</h3>
              <p className="text-gray-600">Bank-level encryption and compliance standards</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Zap className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Dedicated Support</h3>
              <p className="text-gray-600">24/7 premium support with dedicated account manager</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Globe className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Global Infrastructure</h3>
              <p className="text-gray-600">Redundant data centers worldwide for reliability</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <CheckCircle2 className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>SLA Guarantee</h3>
              <p className="text-gray-600">99.99% uptime with financial guarantees</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Users className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Unlimited Scaling</h3>
              <p className="text-gray-600">Scale to thousands of users seamlessly</p>
            </Card>
          </div>
        </div>
      </section>

      <SolutionExtras s={S} />

      {/* CTA */}
      <section className="px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <Card className="p-12 text-center bg-gradient-to-br from-[#0a1f2e] to-[#0a2f3e] text-white">
            <h2 className="text-3xl font-bold mb-4">Ready to transform your enterprise communications?</h2>
            <p className="text-xl text-gray-300 mb-8">Contact our enterprise sales team</p>
            <Button 
              size="lg"
              style={{ backgroundColor: '#c8ff00', color: '#0a1f2e' }}
              className="hover:opacity-90 font-semibold"
              onClick={() => window.location.href = '/contact'}
            >
              Contact Sales
            </Button>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default Enterprise;